import { Box, Typography } from '@mui/material'

interface Props {
  text: string
  color: string
}

export default function PromptPreview({ text, color }: Props) {
  const parts = text.split(/(\{[A-Z_]+\})/g)
  return (
    <Box
      component="pre"
      sx={{
        m: 0,
        fontSize: 11.5,
        lineHeight: 1.75,
        fontFamily: "'Courier New', monospace",
        color: 'text.primary',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        bgcolor: 'grey.50',
        p: 2,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        overflowY: 'auto',
        maxHeight: 320,
      }}
    >
      {parts.map((part, i) =>
        /^\{[A-Z_]+\}$/.test(part) ? (
          <Box
            key={i}
            component="span"
            sx={{
              bgcolor: color + '22',
              color,
              fontWeight: 700,
              borderRadius: '3px',
              px: 0.25,
            }}
          >
            {part}
          </Box>
        ) : (
          <Typography key={i} component="span" sx={{ fontFamily: 'inherit', fontSize: 'inherit' }}>
            {part}
          </Typography>
        ),
      )}
    </Box>
  )
}
